 import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { catchError, EMPTY, map, Observable, throwError } from 'rxjs';
import { AppConfigurationService } from '../base/appConfiguration.service';
 
 


@Injectable({
  providedIn: 'root'
})
export class BlogService {
 
  constructor(private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService) { }

  onGetPost(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/OldConnections/GetPosts`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => new Error(err || "Erro no servidor"))
        })
      );
  }

  onGetPostById(id: string): Observable<any> {
  return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/OldConnections/GetPost/${id}`)

    .pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => new Error(err || "Erro no servidor"))
      })
    );
}
 

   
 
}
